import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-emoji-list',
    templateUrl: './emoji-list.component.html',
    inputs: ['showDialog',],
    outputs: ['onClose', 'emojiClick'],
    standalone: false
})

export class EmojiListComponent {
  public emojiClick = new EventEmitter<string>();
  public showDialog!: boolean;
  public onClose = new EventEmitter<boolean>();
  constructor() { }

  public onDialogClosed(event: any) {
    this.onClose.emit(); 
  }

  public onEmojiClick(event: any) {
    const emojiCharacter = event.emoji.native; 
    this.emojiClick.emit(emojiCharacter); 
  }

}
